module.exports = __webpack_public_path__ + "static/img/domestic.fcc0c099.png";